import Link from 'next/link';
import { IGeneralSettings } from '../../models/IGeneralSettings';
import { socialIcons } from '../../utils/socials';
import { twMerge } from 'tailwind-merge';

export function EremSocials({settings, dark, className}: {settings: IGeneralSettings; dark?:boolean; className?: string}) {
  const displayedTypes = settings.socials;

  return (
    <div className={twMerge('flex gap-x-[15px] items-center', className)}>
      {socialIcons.filter(x => displayedTypes.find(y => y.type === x.type)).map(({Component, type, title}) => <Link rel='noopener noreferrer' target='_blank' href={settings.socials.find(s => s.type === type)?.url || ''} title={title} key={type} className={twMerge('grid place-items-center aspect-square')}><Component dark={dark} className='[&>*]:w-[31px]'/></Link>)}
  </div>
  )
}